import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../environment/environment';
import { Observable } from 'rxjs';
import { ExportCasellarioFilters, ExportCasellarioItemDto, ExportCasellarioListDto } from '../model/export-casellario-data';

@Injectable({
  providedIn: 'root'
})
export class ExportCasellarioService {

  private _http = inject(HttpClient);
  private export_casellario_api: string = `${environment.baseUrl}/export-casellario`;

  getIscrittiExport(data: ExportCasellarioFilters): Observable<ExportCasellarioListDto>{
    return this._http.post<ExportCasellarioListDto>(`${this.export_casellario_api}/lista-export`, data);
  }
  esporta(lista: ExportCasellarioItemDto[]): Observable<any>{
    return this._http.post(`${this.export_casellario_api}/esporta`, lista, { responseType: 'blob' });
  }
  esportaDaDelibera(deliberaId: number): Observable<any>{
    return this._http.post(`${this.export_casellario_api}/esporta-da-delibera/${deliberaId}`, {}, { responseType: 'blob' });
  }
}
